import { CollectionList } from "../types/collections";
export const USER_DEFINED = "user_defined";

export const BENTO_EXPERIENCE = 'BENTO_GRID';
export const METRO_EXPERIENCE = 'MASONRY';
export const CAROUSEL_EXPERIENCE = 'CAROUSEL';
export const DEAL_ROOM_EXPERIENCE = "DEAL_ROOM";

export const DEFAULT_COLLECTION_LIST: CollectionList[] = [{
  id: 'all',
  name: 'All Collections',
  smart: true,
}, {
  id: 'owned_by_me',
  name: 'Owned by me',
  smart: true,
}, {
  id: 'collaborated',
  name: 'Collaborated',
  smart: true,
}, {
  id: 'live',
  name: 'Live',
  smart: true,
}, {
  id: 'templates',
  name: 'Templates',
  smart: true,
}];

export const EXPERIENCES: any[] = [{
  id: BENTO_EXPERIENCE,
  name: 'Bento',
  description: 'A flexible wall to showcase your assets with unlimited possibilities for layouts—like a buffet for your content!',
  icon: '/images/collections/experiences/bento.png',
}, {
  id: METRO_EXPERIENCE,
  name: 'Metro',
  description: 'Present your assets in a vertical tile wall. complete with a customisable cover page, perfect for when you want to showcase multiple assets in a single view',
  icon: '/images/collections/experiences/masonry.svg',
}, {
  id: CAROUSEL_EXPERIENCE,
  name: 'Carousel',
  description: 'Display your assets in an engaging carousel format that scrolls horizontally in an order. Round and round we go!',
  icon: '/images/collections/experiences/carousel.svg',
}];

export const ASSET_VIEWERS: any[] = [{
  id: 'LIST_VIEWER',
  name: 'List Viewer',
  description: 'A dual panel view showcasing the full list on the left and individual assets in detail on the right',
  icon: '/images/collections/viewers/list_viewer.svg',
}, {
  id: 'IMMERSE_VIEWER',
  name: 'Immerse Viewer',
  description: 'Immerse yourself in the asset, with all content presented seamlessly up top',
  icon: '/images/collections/viewers/immerse_viewer.svg',
}, {
  id: 'GALLERY_VIEWER',
  name: 'Gallery Viewer',
  description: 'Browse your collection like a photo gallery, with smooth scrolling and full screen viewing',
  icon: '/images/collections/viewers/gallery_viewer.svg',
}];

export const DEFAULT_EXPERIENCE: string = BENTO_EXPERIENCE;
export const DEFAULT_ASSET_VIEWER: string = "LIST_VIEWER";